module.exports = __webpack_public_path__ + "static/media/Hero-earth.c486dea5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Hero-earth.jpg
// module id = 282
// module chunks = 1